import React, { useState } from 'react';
import Layout from '../components/Layout';
import BusinessInformationTab from './tabs/BusinessInformationTab';
import BrandingTab from './tabs/BrandingTab';
import LocationTab from './tabs/LocationTab';
import WharehouseManagementTab from './tabs/WharehouseManagementTab';
import ProductsTab from './tabs/ProductsTab';
import DeliveryServices from './tabs/DeliveryServices';
import TicketsTab from './tabs/TicketsTab';
import WeightGroupsTab from './tabs/WeightGroupsTab';
import Carriers from './tabs/Carriers';
import StatusTab from './tabs/StatusTab';

const Settings = () => {
  const [activeTab, setActiveTab] = useState('businessInformation');

  const items = [
    { tab: 'businessInformation', tabName: 'Business Information', tabPage: <BusinessInformationTab /> },
    { tab: 'branding', tabName: 'Branding', tabPage: <BrandingTab /> },
    // { tab: 'location', tabName: 'Location', tabPage: <LocationTab /> },
    // { tab: 'status', tabName: 'Status', tabPage: <StatusTab /> },
    // { tab: 'warehouseManagement', tabName: 'Warehouse Management', tabPage: <WharehouseManagementTab /> },
    // { tab: 'products', tabName: 'Products', tabPage: <ProductsTab /> },
    // { tab: 'deliveryServices', tabName: 'Delivery Services', tabPage: <DeliveryServices /> },
    // { tab: 'tickets', tabName: 'Tickets', tabPage: <TicketsTab /> },
    // { tab: 'weightGroups', tabName: 'Weight Groups', tabPage: <WeightGroupsTab /> },
    // { tab: 'carriers', tabName: 'Carriers', tabPage: <Carriers /> },
  ];

  return (
    <Layout>
      <div className="w-full p-6">
        <h2 className="text-3xl font-bold mb-6">Settings</h2>
        
        <div className="flex gap-6">
          {/* Sidebar Navigation */}
          <div className="w-64 bg-base-200 rounded-lg p-4">
            <ul className="menu gap-2">
              {items.map(({ tab, tabName }) => (
                <li key={tab}>
                  <a
                    onClick={() => setActiveTab(tab)}
                    className={`cursor-pointer ${
                      activeTab === tab 
                        ? 'active bg-primary text-primary-content font-semibold' 
                        : 'hover:bg-base-300'
                    }`}
                  >
                    {tabName}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Main Content Area */}
          <div className="flex-1 bg-base-100 rounded-lg shadow-xl p-6">
            {items.map(({ tab, tabPage }) => (
              activeTab === tab && (
                <div key={tab}>
                  {tabPage}
                </div>
              )
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Settings;
